import React, { useState, useContext } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Tooltip from "@mui/material/Tooltip";
import { Grid, Container, Button } from "@mui/material";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import iconoinfo from "images/icono-info.svg";
import Consultasgeograficas from "images/consulta-geografica-logo.svg";
import Indicadores from "images/indicadores-biodiversidad-icono.svg";
import Portafolio from "images/portafolio-icono.svg";
import Comunitario from "images/monitoreo-comunitario-icono.svg";
import compensacionAmbiental from "images/compensacion-ambiental-icono.svg";
import { Link } from "react-router-dom";
import AppContext from "app/AppContext";

function PrevArrow(props) {
    const { onClick } = props;
    return (
        <div className="prev-arrow" onClick={onClick}>
            <KeyboardArrowLeft fontSize="large" />
        </div>
    );
}

function NextArrow(props) {
    const { onClick } = props;
    return (
        <div className="next-arrow" onClick={onClick}>
            <KeyboardArrowRight fontSize="large" />
        </div>
    );
}

function Carrousel({ setActiveTab, setShowQueEs }) {
    const { user } = useContext(AppContext);
    const [activeModule, setActiveModule] = useState(null);

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: true,
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 3 } },
            { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 2 } },
            { breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 2 } },
            { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        ],
    };

    const modules = [
        { id: 1, title: "Consultas Geográficas", image: Consultasgeograficas, link: "/Consultas", auth: false },
        { id: 2, title: "Indicadores de Biodiversidad", image: Indicadores, link: "/Indicadores", auth: false },
        { id: 3, title: "Portafolios", image: Portafolio, link: "/Portafolios", auth: false },
        //{ id: 4, title: "Monitoreo Comunitario", image: Comunitario, link: "/Monitoreo", auth: false },
        { id: 4, title: "Compensación Ambiental", image: compensacionAmbiental, link: "/GEB/Compensaciones", auth: true },
    ];

    const availableModules = user ? modules : modules.filter((module) => !module.auth);


    const handleClick = (id) => {
        if (activeModule === id) {
			setActiveModule(null);
			setActiveTab(0);
			setShowQueEs(true);
        } else {
            setActiveModule(id);
            setActiveTab(id);
            setShowQueEs(false);
        }
    };


    return (
        <div id="CarrouselBio" className="slider-container imagen-fondo">
            <Container maxWidth="lg" sx={{ py: 2 }}>
                <Grid container spacing={2} alignItems="center" justifyContent="center">
                    <p>EXPLORA NUESTROS MÓDULOS</p>
                </Grid>
                <Slider {...settings}>
                    {availableModules.map((module) => (
						<div key={module.id} className="ModuloPrincipal" style={{ height: "auto", padding: 12 }}>
							<div className="moduactivo active" >
								<Link to={module.link}>
									<img className="Modulos" src={module.image} alt={module.title} style={{ width: "65%", height: "auto", cursor: "pointer" }} />
								</Link>

								<Grid container alignItems="center" className="contenedor activo" >
									<Grid item xs={12} sm={8} md={9} lg={10} sx={{ textAlign: { xs: "center", sm: "left" }, minHeight:"54px", display:"flex"}}>
										<Link to={module.link} style={{alignSelf:"center", padding:"5px 0"}}>
											<span>{module.title}</span>
										</Link>
									</Grid>

									<Grid className="btncricle" item xs={12} sm={4} md={3} lg={2} sx={{ textAlign:"center" }}>
										<Tooltip title="Más información" arrow>
											<Button
												onClick={(event) => {
													event.preventDefault()
													handleClick(module.id)}
												}
												style={{
													backgroundColor: activeModule === module.id ? "#e84a5f" : "unset",
													border: "2px solid #fff",
													padding: "10px",
												}}
											>
												<img src={iconoinfo} alt="Información" />
											</Button>
										</Tooltip>
									</Grid>
								</Grid>
							</div>
						</div>
                    ))}
                </Slider>
            </Container>
        </div>
    );
}

export default Carrousel;
